import { render, staticRenderFns } from "./Notificado.vue?vue&type=template&id=3441005f&scoped=true"
import script from "./Notificado.vue?vue&type=script&lang=js"
export * from "./Notificado.vue?vue&type=script&lang=js"
import style0 from "./Notificado.vue?vue&type=style&index=0&id=3441005f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3441005f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3441005f')) {
      api.createRecord('3441005f', component.options)
    } else {
      api.reload('3441005f', component.options)
    }
    module.hot.accept("./Notificado.vue?vue&type=template&id=3441005f&scoped=true", function () {
      api.rerender('3441005f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/completaInfo/Notificado.vue"
export default component.exports